import React, { Component } from "react";
import "../initialPage/initial.scss";
import "./Tabs.css";
import { withRouter, } from "react-router-dom";
import { Col, Row, Container } from 'bootstrap-4-react';

class TabsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    
  }

  componentDidMount() {  }

  render() {

    return (
      <Container>
        <Row className="tabsPage__tabs">
          {
            this.props.initState.tabsArray.map((t,e) => (
              <Col onClick={ () => { this.changeTabActive(t) }} key={`tab-${e}`} className={ `tabsPage__col ${ t.active === 1 ? 'active' : '' }` }>
                <img alt={"img"} src={ t.img } className={`${t.active === 1 ? 'active' : ''}`} />
                <p style={{ color: t.active === 1 ? '#111' : '#777', }}>{t.name}</p>
                {/* t.active === 1 ? (<div className="tabsPage__borderActive"></div>) : null */}
              </Col>
            ))
          }
        </Row>
      </Container>
    );
  }

  changeTabActive(item) {

    let { tabsArray, indexSucursalSelected } = this.props.initState

    for(var a in tabsArray) {
      tabsArray[a].active = 0
      if( tabsArray[a].index === item.index ) {
        if(item.index === 1) {
          tabsArray[a].active = 1
          this.props.history.push('/')
        } else {
          if(item.index === 2) {
            if(indexSucursalSelected > 0) {
              //Redirecciona
              tabsArray[a].active = 1
            } else {
              alert('No haz seleccionado una sucursal.')
              tabsArray[0].active = 1
            }

          } else if(item.index === 3) {
            //Sin uso
            tabsArray[a].active = 1
          } else if(item.index === 4) {
            //Configurar precios
            this.props.history.push('/actualiza-costos')
          }
        }

        /*
        if(item.index === 1) {
          // this.props.initsetState({viewApp: 'admin'})
          this.props.history.push('/')
        } else {
          alert('Módulo en desarrollo')
          return false
          if(item.index === 2) {
            // this.props.initsetState({viewApp: 'ejecutivo'})
            this.props.history.push('/registra-gastos')
          } else if(item.index === 3) {
            this.props.history.push('/actualiza-costos')
          }
        }
        */
      }
    }
    this.props.initsetState({ tabsArray })
  }

};

export default withRouter(TabsPage)